// Invitations waiting for this person (`invitations/{id}`, `toUID == uid`), written only by the server's `share`
// function. Read as the kit's listener reads them (FirestoreBackend.listenToInvitations): one without a share is no
// invitation; the rest have defaults.

import type { Fields } from "../core/records";

export interface Invitation {
  /** The document's id, which the `share` function's "accept" and "decline" take. */
  id: string;
  shareID: string;
  /** "list", "project" or "area"; "list" when it says nothing. */
  kind: string;
  title: string;
  /** Who invited. */
  fromName: string;
}

export function decodeInvitation(id: string, data: Fields): Invitation | null {
  const shareID = data.shareID;
  if (typeof shareID !== "string") return null;
  const text = (value: unknown, fallback: string) => (typeof value === "string" ? value : fallback);
  return { id, shareID, kind: text(data.kind, "list"), title: text(data.title, ""), fromName: text(data.fromName, "") };
}
